import React from 'react';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Benefits } from './components/Benefits';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Transformation } from './components/Transformation';
import { BusinessSection } from './components/BusinessSection';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen font-sans text-text-main bg-base selection:bg-fuchsia selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <TrustBar data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Benefits data-id="element-7" />
        <Modules data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Transformation data-id="element-10" />
        <BusinessSection data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}